import { createContext, useContext } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { sessionState, updateToken } from './sessionState';

export const GoogleAuthSessionContext = createContext();

export function useGoogleAuthSession() {
  const context = useContext(GoogleAuthSessionContext);
  if (!context) {
    throw new Error('useGoogleAuthSession must be used within a GoogleAuthSessionProvider');
  }
  return context;
}

export function useGoogleAuthLogin() {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      sessionState.isLoading = true;
      try {
        // Handle the token response from Google
        // You might need to get user info and/or exchange for your backend token
        const userInfoResponse = await fetch(
          `https://www.googleapis.com/oauth2/v2/userinfo?access_token=${tokenResponse.access_token}`
        );
        const userInfo = await userInfoResponse.json();
        
        // Update session with user info and token
        await updateToken(tokenResponse.access_token);
        
      } catch (error) {
        console.error('Error during Google login:', error);
      } finally {
        sessionState.isLoading = false;
      }
    },
    onError: (error) => {
      console.error('Google login error:', error);
      sessionState.isLoading = false;
    }
  });

  return login;
}
